<template>
<div :class="bem()" v-if="isWechatWay || isPhoneOrEmialWay">
    <div :class="bem('tooltip')">
        <span v-if="isWechatWay">切换为账号密码登录</span>
        <span v-if="isPhoneOrEmialWay">切换为微信扫码登录</span>
    </div>
    <div :class="bem('content')" @click="vm.switchType('phone')" v-if="isWechatWay">
        <img :class="bem('icon-phone')" src="https://cdn.dancf.com/fe-assets/20220328/9f6d051079e70fc2dbf46e279589c190.svg" alt="">
    </div>
    <div :class="bem('content')" @click="vm.switchType('wechat')" v-if="isPhoneOrEmialWay">
        <img :class="bem('icon')" src="https://cdn.dancf.com/fe-assets/20220328/7cbe3125d4341b9bc493cec10e78bc5b.svg" alt="">
    </div>
</div>

</template>
<script>
import _Tooltip from "@gaoding/gdui/lib/tooltip";
import _Icon from "@gaoding/gdui/lib/icon";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import bemMixin from './bem';
export default {
  name: 'g-auth-other-way-switch-login',
  inject: ['vm'],
  components: {
    Icon: _Icon,
    Tooltip: _Tooltip
  },
  mixins: [bemMixin],
  props: {
    type: {
      type: String,
      default: 'phone' // wechat: 展示微信登录 icon   phone: 展示手机登录 icon

    }
  },
  computed: {
    isWechatWay: function isWechatWay() {
      return ['wechat', 'qq', 'qiyeWechat'].includes(this.type);
    },
    isPhoneOrEmialWay: function isPhoneOrEmialWay() {
      return ['phone', 'smsLogin', 'email', 'emailCode'].includes(this.type);
    }
  },
  methods: {
    isIncludesWay: function isIncludesWay(type) {
      return this.vm.loginWays.includes(type);
    }
  }
};
</script>
<style>
/*
 * @Author: 天吾
 * @Date: 2019-01-23 16:29:55
 * @Last Modified by: 天吾
 * @Last Modified time: 2019-11-22 11:24:33
 */
/*
    size 统一用  sm base lg  表示,  对于不能满足的情况, 仿照衣服尺寸加上 x(EXTRA) 比如  font-size-xlg 表示特大
*/
.g-auth-other-way-switch-login__tooltip {
  position: absolute;
  right: 54px;
  top: 20px;
  z-index: 9;
  padding: 5px 12px;
  color: #2254F4;
  font-size: 14px;
  line-height: 22px;
  border-radius: 4px;
  background: #F0F6FF;
}
.g-auth-other-way-switch-login__tooltip::after {
  display: block;
  content: ' ';
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0px;
  width: 10px;
  height: 10px;
  margin: auto -2px;
  border-radius: 1px;
  background: #F0F6FF;
  transform: rotate(45deg);
}
.g-auth-other-way-switch-login__content {
  position: absolute;
  right: 0;
  top: 0;
  width: 62px;
  height: 62px;
  background: #F0F6FF;
  cursor: pointer;
}
.g-auth-other-way-switch-login__content::before {
  display: block;
  content: ' ';
  position: absolute;
  top: 0;
  left: 0;
  border: 31px solid;
  border-color: transparent transparent #ffffff #ffffff;
}
.g-auth-other-way-switch-login__icon {
  display: block;
  line-height: 0;
  width: 42px;
  height: 42px;
  margin: 10px;
}
.g-auth-other-way-switch-login__icon-phone {
  display: block;
  line-height: 0;
  width: 41px;
  height: 39px;
  margin: 10px;
}

</style>
